export const normalizeEmail = (email) => {
    let value = email.includes("#ext#") ? email.split("#") : email;
    if (Array.isArray(value)) {
        return value[0].replace("_", "@");
    }
    else {
        return value;
    }

}